export class PacUtilityService {
    public static extractPACsFromString(pacs: string): string[] {
        let pacsString = pacs.trim();

        let hasNewLine = pacsString.indexOf('\n') >= 0;
        let hasCarriageReturn = pacsString.indexOf('\n') >= 0;
        // let hasSpace = pacsString.indexOf(' ') >= 0;
        do {
            pacsString = pacsString.replace('\n', '');
            // pacsString = pacsString.replace('\r', '');
            hasNewLine = pacsString.indexOf('\n') >= 0;
            hasCarriageReturn = pacsString.indexOf('\n') >= 0;
            // hasSpace = pacsString.indexOf(' ') >= 0;
        } while (hasNewLine || hasCarriageReturn);

        return pacsString.split(',');
    }

    /**
     * This is not a complete way to validate PACs the complete check will be done in back-end
     * This is just a sanitation check for checking PAC's length and simple formats
     */
    public static validatePacFormat(pac: string): boolean {
        const noDashRegex = /^([a-zA-Z0-9]{12,13}(,)?)$/;
        // const thirteenCharacterRegex = /^([a-zA-Z0-9]{5}-[a-zA-Z0-9]{4}-[a-zA-Z0-9]{4})$/;
        // const twelveCharacterRegrex = /^([a-zA-Z0-9]{4}-[a-zA-Z0-9]{4}-[a-zA-Z0-9]{4})$/;
        return noDashRegex.test(pac);
    }
}
